import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import mediamodifier from "../../../../config/mediamodifier";
import { getFile } from "../../redux/creators/fileCreators";
import ProductCard from "./ProductCard";
import { device } from "../../../../utils/breakPoints";

/**
 * Container component for Product Recommendations section
 *
 * @return {Object}
 */
export default function ProductRecommendations() {
  const {
    file,
    files,
    selectedProduct
  } = useSelector((state) => ({
    file: getFile(state).file,
    files: getFile(state).files,
    ...state.threekit
  }));

  // Recommendations collection, passed in from single-image-product section
  const recommendedProducts = window.recommendations;

  /**
   * Filter out products with sku type that matches the selected product
   *
   * Sku examples: CP-CAN-8X8-0000-001 CP-MUG-BASIC-0000-001
   * The second section of the sku references the type of product.
   * Return only products that are not the same type
   */
  const filteredProducts = () => {
    return recommendedProducts.filter((product) => {
      const selected = selectedProduct.variants[0].sku;
      const current = product.variants[0].sku;

      const selectedType = selected.split("-")[1];
      const currentType = current.split("-")[1];

      return selectedType !== currentType;
    });
  }

  /**
   * Get four recommended products to display in cards
   * Check to make sure there are four products returned
   * from the filtered function
   */
  const getRecommended = () => {
    // Filter recommended product
    const recommendedFiltered = filteredProducts().slice(0, 4);

    // Check to make sure there are four
    return recommendedFiltered.length !== 4
      ? recommendedProducts.slice(0, 4)
      : recommendedFiltered;
  }

  /**
   * Gets the current product's mockup from config file
   * using the product's sku type
   */
  const getProductMockup = (product) => {
    const sku = product.variants[0].sku
    const type = sku.split("-")[1];
    return mediamodifier[type] || null;
  }

  /**
   * Determines the uploaded image file to use in the
   * renders. For single uploads, use the file. For multi uploads
   * use the first file.
   */
  const getFirstFile = () => {
    return file || files[Object.keys(files)[0]] || null;
  }

  return (
    <ProductRecommendationsContainer>
      <Heading>You may also like</Heading>
      <ProductsContainer>
        {getRecommended().map((product) => {
          return (
            <ProductCard
              key={product.id}
              product={product}
              file={getFirstFile()}
              mockup={getProductMockup(product)}
            />
          );
        })}
      </ProductsContainer>
    </ProductRecommendationsContainer>
  );
}

const ProductRecommendationsContainer = styled.div`
  width: 100%;
  max-width: 1500px;
  background: #F8F4F4;
  padding: 50px 30px;
  margin-right: auto;
  margin-left: auto;
`;
const Heading = styled.h2`
  font-family: "bookmania";
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 44px;
  color: #000000;
  margin: 0 0 40px;
`;
const ProductsContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  @media ${device.tablet} {
    flex-direction: column;
  }
`;
